/**
 * Area Page Observability Event Names
 *
 * These constants define the event names tracked for area page observability.
 * Used with NewRelic Browser APM for monitoring critical city pages.
 */

/**
 * Event tracked when an area page successfully loads
 */
export const AREA_PAGE_LOAD_SUCCESS = 'area_page_load_success' as const;

/**
 * Critical alert event tracked when a critical city returns zero listings
 */
export const AREA_PAGE_CRITICAL_CITY_ZERO_LISTINGS = 'area_page_critical_city_zero_listings' as const;

/**
 * Default configuration values for area page observability
 */
export const AREA_PAGE_OBSERVABILITY_DEFAULTS = {
  /** Default value when observability is not configured */
  OBSERVABILITY_ENABLED: false,
  /** Default value when area page observability is not configured */
  AREA_PAGES_ENABLED: false,
  /** Default empty array for critical cities */
  CRITICAL_CITIES: [] as string[],
  /** Alert priority for critical zero listing events */
  CRITICAL_ALERT_PRIORITY: 'high' as const,
} as const;

